import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Smartrade } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useResendOrderMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Smartrade.ResendOrderBody) => {
      return api.smartrade.resendOrder(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Order resent for order ${_params.clordid}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error resending order for ${_params.clordid}`)
    },
  })
}

export const useResendConfirmationEmailMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Smartrade.ResendOrderBody) => {
      return api.smartrade.resendConfirmationEmail(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Confirmation Email resent for order ${_params.clordid}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error resending Confirmation Email for ${_params.clordid}`)
    },
  })
}

export const useResendNotificationEmailMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Smartrade.ResendOrderBody) => {
      return api.smartrade.resendNotificationEmail(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Notification Email resent for order ${_params.clordid}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error resending Notification Email for ${_params.clordid}`)
    },
  })
}

export const useUpdateSecurityEntryMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: Smartrade.UpdateSecurityEntryBody) => {
      return api.smartrade.updateSecurityEntry(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully updated ${_params.oldValue} to ${_params.newValue}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error updating ${_params.oldValue} to ${_params.newValue}`)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['smartrade', 'data'] })
    },
  })
}

export const useAddSecurityEntryMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: Smartrade.AddSecurityEntryBody) => {
      return api.smartrade.addSecurityEntry(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully added ${_params.isin} to Smartrade`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error adding ${_params.isin} to Smartrade`)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['smartrade', 'data'] })
    },
  })
}

export const useUpdateClientEmaildistMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: Smartrade.UpdateClientEmaildistParams) => {
      return api.smartrade.updateClientEmailDist(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully updated distribution list for client ${_params.data.firmid}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error updating distribution list for client ${_params.data.firmid}`)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['smartrade', 'clients'] })
    },
  })
}
